export const fromCamelCase = (value: string) => {
  value = value.replace(/[A-Z]/g, " $&");
  
  return value[0] + value.slice(1);
}